
const isLocalhost = window.location.hostname === "localhost";
// src/msalConfig.js
// console.log("REACT_APP_REDIRECT_URI:", process.env.REACT_APP_REDIRECT_URI);
export const msalConfig = {
    auth: {
      clientId: "a1d8e162-0ec5-4d0d-a542-548c241b1c26",
      authority: "https://login.microsoftonline.com/dfa4ba20-6f31-4c00-8b71-2ee48e129555", 
      redirectUri: isLocalhost ? "http://localhost:3000/" : process.env.REACT_APP_HOST_LINK //"https://main.ddr6zdxkagq8q.amplifyapp.com/", 
      // ^ Redirects to the current origin after login. Ensure this is listed in Azure AD app > Redirect URIs.
    },
    cache: {
      cacheLocation: "localStorage", 
      storeAuthStateInCookie: false  
    }
  };
  
  export const loginRequest = {
    scopes: ["openid", "profile", "User.Read"]
  };
  